<template>
  <div>
    <c-checkbox
      v-if="name"
      name="mtm-shop"
      :id="name + id"
      :value.sync="select"
      @change="onInputValueChange"
    >
      <template #label-content>
        {{ name }}
      </template>
    </c-checkbox>
    <c-checkbox
      v-if="name"
      name="mtm-shop-item"
      :label-class="`w-full`"
      :value.sync="select"
      @change="onInputValueChange"
    >
      <template>
        <div class="cart-item flex flex-row w-full">
          <div class="img-wrap mr-3">
            <img
              width="75"
              :src="require('@/assets/Purchase/mobile_scanner.svg')"
              alt="Mobile Scanner"
            />
          </div>
          <div class="info-wrap">
            <div class="item-name">
              <span v-if="data.itemPrice">${{ data.itemPrice }} </span>
              <br /><span v-if="data.itemName">{{ data.itemName }} </span>
            </div>
            <c-value-toggler
              class="ml-auto"
              :value.sync="value"
              :disabled="!select"
              @change="onInputValueChange"
            />
          </div>
        </div>
      </template>
    </c-checkbox>
  </div>
</template>

<script>
import CCheckbox from '@/components/common/Form/CCheckbox.vue';
import CValueToggler from '@/components/common/Form/CValueToggler.vue';

export default {
  name: 'ShopItem',
  components: {
    CCheckbox,
    CValueToggler,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: vm => ({
    value: vm.quantity,
    select: vm.selected,
  }),
  methods: {
    onInputValueChange() {
      const changedItem = {
        id: this.id,
        name: this.name,
        selected: this.select,
        credits: this.value,
      };
      this.$emit('change', changedItem);
    },
  },
  async mounted() {
    this.onInputValueChange();
  },
  updated() {
    this.onInputValueChange();
  },
};
</script>

<style lang="scss" scoped>
.cart-item {
  background-color: #f7f7f7;
  border-radius: 8px;
  padding: 0.75em;
}

.img-wrap {
  background-color: #fff;
  padding: 0.75em;
}

.item-name {
  @apply text-sm font-normal;
}

.info-wrap {
  @apply flex flex-col justify-between flex-grow;
}
</style>
